<app-entity-mat-dialog-title [title]="data.entityTitle"></app-entity-mat-dialog-title>

<div mat-dialog-content>
  <mat-action-list>
    <button
      *ngFor="let action of data.actions"
      mat-list-item
      type="button"
      (click)="onActionClick(action.action)">
      <mat-icon mat-list-icon>{{ action.icon }}</mat-icon>
      <span mat-line>{{ action.label }}</span>
    </button>
  </mat-action-list>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" mat-dialog-close type="button">Cancel</button>
</mat-dialog-actions>
